<template lang="pug">
  div
    form.w-full.max-w-xl.mt-6(v-on:submit="sendRequest")
      .flex.flex-wrap.-mx-3
        .w-full.px-3
          label(for='address') Address
          input#address(placeholder='0.0.0.0' type="text" v-model="address")
          p.text-gray-600.text-xs.italic IP Address or CIDR prefix.
      input.button.mt-3(type="submit" v-bind:disabled="loading" v-bind:class="{ 'opacity-50': loading }" value="Send")
    div.text-gray-100.font-mono.bg-black.rounded.p-4.mt-6(v-if="response || hasError")
      div.text-red-400(v-if="hasError") {{errorMessage}}
      div.text-sm(v-else v-for="route in response")
        div {{route.prefix}}
        .param
          span.paramName Next hop:&nbsp;
          span {{route.next_hop}}
        .param
          span.paramName As path:&nbsp;
          span {{route.as_path.join(', ')}}
        .param
          span.paramName Community:&nbsp;
          span {{route.community.join(' - ')}}
        .param
          span.paramName Local pref:&nbsp;
          span {{route.local_pref}}
</template>
<style lang="postcss" scoped>
.param {
  @apply ml-6 flex;
}

.paramName {
  @apply text-gray-600 flex-shrink-0;
  width: 100px;
}
</style>
<script>
import common_computed from "@/mixins/common_computed";
import errors from "@/mixins/errors";

export default {
  mixins: [common_computed, errors],
  data() {
    return {
      address: "",
      response: null,
    };
  },
  computed: {
    searchParams() {
      return new URLSearchParams({
        address: this.address,
      });
    },
  },
  methods: {
    sendRequest(e) {
      e.preventDefault();
      this.clearError();
      this.response = null;
      this.loading = true;
      fetch(`${this.selectedHost}/v1/routes/show?${this.searchParams}`, {
        method: "GET",
      })
        .then((resp) => {
          this.loading = false;
          if (!resp.ok) {
            this.hasError = true;
          }
          return resp.json();
        })
        .then((json) => {
          if (this.hasError) {
            this.setError(json.error.description);
          } else {
            this.response = json.routes;
          }
        })
        .catch((error) => {
          console.error(error);
          this.setError("Unable to lookup BGP Routes, an error occurred");
        });
    },
  },
};
</script>
